import { ReactNode } from "react";
interface NotificationCardProps {
  className?: string;
  text?: string | null;
  children?: ReactNode;
}

const NotificationCard = ({
  children,
}: NotificationCardProps) => {
  return (
    <div className={"bg-white rounded-lg mt-2 border border-[#e9e9e9] p-4"}>
      {/* {text && (
        <p className={twMerge("text-sm text-gray-500", className)}>{text}</p>
      )} */}
      {children}
    </div>
  );
};

export default NotificationCard;
